import { render, staticRenderFns } from "./YubikeySetupPermissions.popup-chunk.vue?vue&type=template&id=0abe9c4e"
import script from "./YubikeySetupPermissions.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./YubikeySetupPermissions.popup-chunk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports